












import {Component, Prop} from 'vue-property-decorator'
import DataTable from './proxy/DataTable.vue'
import Container from '@/components/proxy/Container.vue'
import TimeOverrides from '@/components/TimeOverrides.vue'

@Component({
  name: 'BulkOverrides',
  components: {Container, DataTable},
})
export default class BulkOverrides extends TimeOverrides {
  @Prop() public bulkOverrides!: BulkOverrides[]
  @Prop({
    type: Boolean,
    default: true,
  }) public title!: boolean

  public days: string[] = [
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat',
    'sun',
  ]
}
